import { CsvColumn, CsvDataType } from '../../types/CsvTemplate'
import { NeoniApi, RequestOptions } from '../api'

export interface CsvTemplateMetadata {
	success: boolean
	template: CsvColumn[]
	maxRowsPerUpload: number
}

const isCsvColumn = (value: unknown): value is CsvColumn => {
	if (typeof value !== 'object' || value === null) return false
	return 'name' in value && typeof value.name === 'string'
		&& 'type' in value && Object.values(CsvDataType).some((type) => type === value.type)
		&& 'isMissing' in value && typeof value.isMissing === 'boolean'
		&& 'isRequired' in value && typeof value.isRequired === 'boolean'
		&& (!('field' in value) || typeof value.field === 'string')
		&& (!('description' in value) || typeof value.description === 'string')
}

export async function getTrainingUsersTemplateMetadata(api: NeoniApi, options?: RequestOptions): Promise<CsvTemplateMetadata> {
	const response: unknown = await api.get('admin/training-sessions/users-csv-template-metadata', options)
	if (typeof response !== 'object' || response === null ||
		!('success' in response) || response.success !== true ||
		!('template' in response) || !Array.isArray(response.template) || !response.template.every(isCsvColumn) ||
		!('maxRowsPerUpload' in response) || typeof response.maxRowsPerUpload !== 'number' ||
		!Number.isInteger(response.maxRowsPerUpload) || response.maxRowsPerUpload < 1) {
		throw new Error('Invalid CSV template metadata')
	}
	return {
		success: true,
		template: response.template,
		maxRowsPerUpload: response.maxRowsPerUpload,
	}
}
